import { useEffect, useState } from 'react';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { MessageTypes } from 'store/declarations/enums/common/declaration-types';
import { getProductTemplateClient } from 'store/products-templates/getProductTemplateClient';
import { ProductTemplate } from 'store/products-templates/products';

interface Props {
    productId?: string;
    country?: DeclarationCountry;
    internalType?: DeclarationInternalType;
    messageType?: MessageTypes;
}

const useProductTemplate = ({ productId, country, internalType, messageType }: Props) => {
    const [productTemplate, setProductTemplate] = useState<ProductTemplate | undefined>(undefined);

    useEffect(() => {
        setProductTemplate(undefined);
        if (!(productId && country && internalType && messageType)) return;

        // The id may change before the response arrives, in which case it is no longer wanted.
        let isCurrent = true;

        getProductTemplateClient(country, internalType, messageType)
            .get(productId)
            .then((response) => {
                if (isCurrent) setProductTemplate(response);
            })
            .catch(() => {
                if (isCurrent) setProductTemplate(undefined);
            });

        return () => {
            isCurrent = false;
        };
    }, [productId, country, internalType, messageType]);

    return productTemplate;
};

export default useProductTemplate;
